import { Loading } from "fearless-common-ui";
import { Alert, Button } from "react-bootstrap";
import { Link } from "react-router-dom";
import { concepts } from "fearless-common";
import useGet from "../../components/hooks/useGet";
import { Pages } from "../../components/layout";
import { routes } from "../../utils";

/** Triggers a browser download of the recovery codes as a plain-text file. */
function downloadCodes(codes: string[]): void {
    const blob = new Blob([codes.join('\n')], { type: 'text/plain' });
    const url = window.URL.createObjectURL(blob);
    const a = document.createElement('a');
    a.href = url;
    a.download = '2fa-recovery-codes.txt';
    a.click();
    window.URL.revokeObjectURL(url);
}

/**
 * Success page shown after two-factor authentication is enabled.
 * Displays one-time recovery codes the user should save securely.
 */
export default function TwoFactorAuthenticationSuccess() {
    const { data: codes, error, isLoading } = useGet<string[]>({
        endpoint: '/user/two-factor-recovery-codes',
        dataKey: 'codes',
    });

    return (
        <Pages.Centred width="xs" className="text-center">
            <h2>Two factor authentication enabled!</h2>
            <p>Please save the security codes displayed below in a safe way.</p>

            {isLoading && <Loading />}
            {error && <Alert variant="danger">{error}</Alert>}

            <section>
              <Button className="mb-5" variant="outline-primary" onClick={() => codes && downloadCodes(codes)}>
                Download codes (.txt)
              </Button>
              <table className="table table-light table-sm">
                  {Array.isArray(codes) && codes.map((code) => (
                      <tr key={code}>
                          <td className="mb-1">
                              <code>{code}</code>
                          </td>
                      </tr>
                  ))}
              </table>
            </section>

            <Link to={routes.security}>
                <Button>Back to {concepts.Security}</Button>
            </Link>
        </Pages.Centred>
    );
}
